import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translocoSvc = inject(TranslocoService);
  const lang = translocoSvc.getActiveLang();
  const clonedRequest = req.clone({
    setHeaders: {
      'Accept-Language': lang,
      'App-From': '2'
    }
  })
  return next(clonedRequest);
};
